module.exports = __webpack_public_path__ + "img/person-biking-mountain.72b4d938.svg";